import FeedbacksService from "services/FeedbacksService";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getFeedbacks = createAsyncThunk(
  "feedbacks/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const response = await FeedbacksService.getAllFeedbacks(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Erreur de chargement"
      );
    }
  }
);

export const getFeedbackById = createAsyncThunk(
  "feedbacks/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await FeedbacksService.getFeedbackById(id);
      return response.data?.feedback;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Erreur"
      );
    }
  }
);

export const updateFeedbackStatus = createAsyncThunk(
  "feedbacks/updateStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await FeedbacksService.updateFeedbackStatus(id, { status });
      return { id, feedback: response.data?.feedback, status };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Erreur"
      );
    }
  }
);

export const deleteFeedbackById = createAsyncThunk(
  "feedbacks/deleteById",
  async (id, { rejectWithValue }) => {
    try {
      await FeedbacksService.deleteFeedbackById(id);
      return id;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Erreur"
      );
    }
  }
);

const initialState = {
  feedbacks: [],
  total: 0,
  page: 1,
  pages: 1,
  limit: 20,
  stats: {
    total: 0,
    avgRating: 0,
    avgInstructorRating: 0,
    unseenCount: 0,
  },
  loading: false,
  error: null,
  currentFeedback: null,
};

export const feedbacksSlice = createSlice({
  name: "feedbacks",
  initialState,
  reducers: {
    setCurrentFeedback: (state, action) => {
      state.currentFeedback = action.payload;
    },
    clearCurrentFeedback: (state) => {
      state.currentFeedback = null;
    },
  },
  extraReducers: {
    [getFeedbacks.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getFeedbacks.fulfilled]: (state, action) => {
      state.loading = false;
      state.feedbacks = action.payload?.data || [];
      state.total = action.payload?.totalItems || 0;
      state.page = action.payload?.page || 1;
      state.pages = action.payload?.pages || 1;
      state.limit = action.payload?.limit || 20;
      if (action.payload?.stats) {
        state.stats = action.payload.stats;
      }
    },
    [getFeedbacks.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getFeedbackById.fulfilled]: (state, action) => {
      state.currentFeedback = action.payload;
    },

    [updateFeedbackStatus.fulfilled]: (state, action) => {
      const { id, feedback, status } = action.payload;
      const index = state.feedbacks.findIndex((item) => item._id === id);
      if (index !== -1) {
        if (feedback) {
          state.feedbacks[index] = feedback;
        } else {
          state.feedbacks[index].status = status;
        }
      }
      if (state.currentFeedback && state.currentFeedback._id === id) {
        if (feedback) {
          state.currentFeedback = feedback;
        } else {
          state.currentFeedback.status = status;
        }
      }
      // Recompute stats
      state.stats.unseenCount = state.feedbacks.filter(
        (f) => f.status === "Non Vu"
      ).length;
    },

    [deleteFeedbackById.fulfilled]: (state, action) => {
      const id = action.payload;
      state.feedbacks = state.feedbacks.filter((item) => item._id !== id);
      state.total = Math.max(0, state.total - 1);
      state.stats.total = Math.max(0, (state.stats.total || 1) - 1);
      state.stats.unseenCount = state.feedbacks.filter(
        (f) => f.status === "Non Vu"
      ).length;
    },
  },
});

export const { setCurrentFeedback, clearCurrentFeedback } =
  feedbacksSlice.actions;

export default feedbacksSlice.reducer;
